<template>
    <div class="init_content">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <van-icon size="55" name="close" />
        <p>
            {{ tools.GetLanguageValue('public.app.超出点餐范围') }}
        </p>
    </div>
</template>
<script>
import tools from "../../commons/tools.js"

export default {

  data () {
    return {
      tools: tools
    }
  },
  name: "App",

  components: {},
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.init_content {
    text-align: center;

}
</style>
